export default __webpack_public_path__ + "static/media/icon-success.bd1e9eb6.svg";